///*
// *
// * @param {type} oSettings
// * @returns {undefined}
// */
//
$.fn.dataTableExt.oApi.fnStandingRedraw = function(oSettings) {
//redraw to account for filtering and sorting
// concept here is that (for client side) there is a row got inserted at the end (for an add)
// or when a record was modified it could be in the middle of the table
// that is probably not supposed to be there - due to filtering / sorting
// so we need to re process filtering and sorting
// BUT - if it is server side - then this should be handled by the server - so skip this step
    if(oSettings.oFeatures.bServerSide === false){
        var before = oSettings._iDisplayStart;
        oSettings.oApi._fnReDraw(oSettings);
//DisplayStart has been reset to zero - so lets change it back
        oSettings._iDisplayStart = before;
        oSettings.oApi._fnCalculateEnd(oSettings);
    }
    //draw the 'current' page
    oSettings.oApi._fnDraw(oSettings);
};

//$.fn.dataTable.ext.pager.numbers_length = 5;
$.extend( $.fn.dataTable.defaults, {
    dom:
    "<'row margin-top-10'<'col-sm-4'l><'col-sm-8 text-right'f>>" +
    "<'row'<'col-sm-12'tr>>" +
    "<'row margin-top-15'<'col-sm-5'i><'col-sm-7 text-right margin-top-0'p>>",
    //renderer: 'bootstrap',
    processing: true,
    serverSide: true,

    fnDrawCallback: function( oSettings ) {
        $('[data-toggle="tooltip"]').tooltip();
        $('[data-toggle="popover"]').popover();
        $('[data-toggle="buttons"]').button();
    },
    initComplete: function(settings, json) {
        $('table').removeAttr('style');
        $('table thead tr th').removeAttr('style');
        //var baseSelector = '.dataTables_wrapper .dataTables_length label ';
        //$(baseSelector + 'select').addClass('form-control');
        //$(baseSelector + 'input').addClass('form-control');
    }
} );

//function initColumn(data, name, orderable, searchable, cls) {
//    return {
//        "data": data,
//        "name": name,
//        "orderable": orderable,
//        "searchable": searchable,
//        "class": cls
//    };
//}
//
//function initParam(name, type) {
//    return {
//        "name": name,
//        "type": type
//    };
//}